import React from 'react'

const Sellers = () => {
  return (
    <div>Sellers</div>
  )
}

export default Sellers